module.exports = __webpack_public_path__ + "img/red-arrow.aabd94a8.png";